// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___U53hv","root__number":"style-module__root__number___BmmK9","root__text":"style-module__root__text___kw4Qz"};
    if(module.hot) {
      // 1729151130674
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  